<template>
  <v-col
    cols="4"
    class="white--text text-truncate hidden-sm-and-down"
  >
    <span>{{ currentTime }}</span>
    <span
      :style="{
        borderLeft: '1px solid rgb(255 255 255)',
        margin: '0px 15px'
      }"
    ></span>
    <span>{{ value }}</span>
  </v-col>
</template>

<script>
import { toTime } from "@/utils/datetime"

export default {
  name: "MeetingName",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  beforeDestroy() {
    clearTimeout(this.currentTimeTimeout)
  },
  created() {
    this.getCurrentTime()
  },
  data() {
    return {
      currentTime: null,
      currentTimeTimeout: null
    }
  },
  methods: {
    getCurrentTime() {
      // Refresh time every 10 sec
      this.currentTime = toTime()
      this.currentTimeTimeout = setTimeout(this.getCurrentTime, 10000)
    }
  }
}
</script>
